import React from 'react';
import type { ISignatureInputRadioProps } from './types';
import { classes } from '../../style/TypeOrDrawSignatureInput.st.css';

export const SignatureInputRadio: React.FC<ISignatureInputRadioProps> = ({
  id,
  mode,
  checked,
  onChange,
  label,
  dataHook,
}) => {
  const handleChange = () => {
    onChange(mode);
  };

  const inputId = `radio_${id}_${mode}`;

  return (
    <label
      className={classes.radioLabel}
      htmlFor={inputId}
      data-hook={dataHook}
    >
      <input
        type="radio"
        id={inputId}
        name={`signatureMode_${id}`}
        value={mode}
        checked={checked}
        onChange={handleChange}
        className={classes.radioInput}
      />
      <span className={classes.radioText}>{label} </span>
    </label>
  );
};
